import {
  pushRegistrationContinueEvent,
  pushRegistrationErrorEvent,
  pushRegistrationSuccessfulEvent,
  pushRegistrationSuccessfulMaPageEvent,
} from 'components/shared/googleAnalyticsEvents';
import { getClientSourceType } from 'components/shared/utils/getClientSourceType';
import { CLIENT_SOURCE_TYPE } from 'global.enums';

export const registrationSuccessfulEvent = (
  userIdHash: string,
  clientSourceType: CLIENT_SOURCE_TYPE,
  language: string,
  countryCode: string,
): void => {
  pushRegistrationSuccessfulEvent(userIdHash, getClientSourceType(clientSourceType), language, countryCode);
};

export const registrationSuccessfulMaPageEvent = (userIdHash: string, clientSourceType: CLIENT_SOURCE_TYPE): void => {
  pushRegistrationSuccessfulMaPageEvent(userIdHash, getClientSourceType(clientSourceType));
};

export const registrationErrorEvent = (errorMsg: string): void => {
  pushRegistrationErrorEvent(errorMsg);
};

export const registrationContinueEvent = (): void => {
  pushRegistrationContinueEvent();
};
